import React, { Component } from "react";
import $ from "jquery";
import Swal from "sweetalert2";
import "react-images-uploader/styles.css";
import Constant from "../../../Constant";

export default class BasicSettings extends Component {
  state = {}
  componentDidMount() {
    this.getSiteDetails();
  }
  getSiteDetails = () => {
    var myHeaders = new Headers();
    myHeaders.append("Content-Type", "application/x-www-form-urlencoded");
    myHeaders.append("Authorization", localStorage.getItem("livelms_auth"));

    var urlencoded = new URLSearchParams();
    urlencoded.append("siteId", localStorage.getItem("lms_site_id"));

    var requestOptions = {
      method: "POST",
      headers: myHeaders,
      body: urlencoded,
      redirect: "follow",
    };

    fetch(Constant.getAPI() + "/site/getAll", requestOptions)
      .then((response) => response.json())
      .then((result) => {
        for (var i = 0; i < result.data.length; i++) {
          if (result.data[i].id === localStorage.getItem('lms_site_id')) {
            this.setState({
              name: result.data[i].name,
              description: result.data[i].description,
              MediumId: result.data[i].MediumId,
            });
            if (result.data[i].Medium !== null) {
              this.setState({
                image: result.data[i].Medium.url,
              });
            }
          }
        }
      })
      .catch((error) => console.log("error", error));
  };
  handleImageUpload = (event) => {
    document.getElementById('domain_logo_lable').innerHTML = "";
    let element = $("#domain_logo").get(0);
    $("#domain_logo").empty();
    this.setState({ accepted: element });
    var proof_img = [];
    let obj = {};
    console.log(element.files);
    this.setState({ domain_logo: element.files });
    for (var i = 0; i < element.files.length; i++) {
      var file1 = element.files[i];
      var img = document.createElement("img");
      img.className = "image_square";
      var filePath = URL.createObjectURL(file1);
      img.src = filePath;
      $("#domain_logo_lable").append(img);
    }
  }
  onSave = () => {
    var that = this;
    that.setState({ isSaving: true });
    if (that.state.accepted) {
      that.uploadImg();
    } else {
      that.updateDomainDetails(that.state.MediumId);
    }
  }
  updateDomainDetails = (media_id) => {
    var that = this;
    var data = new URLSearchParams();
    this.setState({ isLoading: true });
    if (media_id !== undefined && media_id !== null && media_id !== "") {
      data.append("logo", media_id);
    }
    // data.append("name", that.state.name);
    data.append("description", that.state.description);
    data.append("siteId", localStorage.getItem('lms_site_id'));
    fetch(Constant.getAPI() + "/site/update", {
      method: "POST",
      headers: {
        "Content-Type": "application/x-www-form-urlencoded",
        "Authorization": localStorage.getItem('livelms_auth')
      },
      body: data
    }).then(function (response) {
      return response.json();
    }).then(function (json) {
      if (json.status === true) {
        Swal.fire("Updated !", "Domain details has been Updated", "success");
        that.setState({ isSaving: false })
        that.getSiteDetails();
      } else {
        Swal.fire("warning !", "Something went wrong..Please Try again after sometime.!", "warning");
        that.setState({ isLoading: false });
        console.log(json);
      }
    });
  }
  uploadImg = () => {
    var that = this;
    var form = $('#domainLogo')[0];
    var data = new FormData(form);
    data.append("siteId", localStorage.getItem("lms_site_id"));
    fetch(Constant.getAPI() + "/media/addGlobal", {
      method: "post",
      headers: {
        "Authorization": localStorage.getItem("livelms_auth")
      },
      body: data
    }).then(function (response) {
      return response.json();
    }).then(function (json) {
      if (json.status === true) {
        that.setState({ MediumId: json.data[0].id });
        that.updateDomainDetails(json.data[0].id);
      } else {
        console.log(json.error);
      }
    });
  };
  handleChange = (event) => {
    this.setState({
      [event.target.name]: event.target.value
    })
  }
  render() {
    return (
      <div>
        <div className="bg-light p-3 my-1">
          <b>IDENTITY</b>
        </div>
        <div className="row m-0 mt-3">
          <div className="col-md-6">
            <div class="form-group row">
              <label class="col-form-label col-4 text-right" for="inputDefault">
                Site Name
              </label>
              <input
                type="text"
                class="form-control col-8"
                placeholder="Site Name"
                id="inputDefault"
                name="name"
                disabled
                onChange={this.handleChange}
                defaultValue={this.state.name}
              />
            </div>
            <div class="form-group row">
              <label class="col-form-label col-4 text-right" for="inputDefault">
                Site Discription
              </label>
              <input
                type="text"
                class="form-control col-8"
                placeholder="Site Discription"
                id="inputDefault"
                name="description"
                onChange={this.handleChange}
                defaultValue={this.state.description}
              />
            </div>
            <div class="form-group row">
              <label class="col-form-label col-4 text-right" for="inputDefault">
                Site Logo
              </label>
              <div className="col-8">
                <form id="domainLogo" name="domainLogo" encType="multipart/form-data" className="text-capitalize">

                  <div className="form-group">

                    <input accept="image/*" onChange={this.handleImageUpload} id="domain_logo" type="file" className="form-control" autoComplete="off" name="media"
                      data-toggle="tooltip" title="Click To Upload Photo"
                    />
                    <div id="domain_logo_lable" className="pt-2">
                      {
                        this.state.image
                          ?
                          this.state.image !== null || this.state.image !== undefined || this.state.image !== {}
                            ?
                            <img src={this.state.image} alt=""
                              height="100" onError={e => {
                                e.target.src = ""
                              }} />
                            :
                            ''
                          :
                          ''
                      }
                    </div>

                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
        {/* <div className="bg-light p-3 my-1">
          <b>LOCALE</b>
        </div>
        <div className="row m-0 mt-3">
          <div className="col-md-6">
            <div class="form-group row">
              <label class="col-form-label col-4 text-right" for="inputDefault">
                Default language
              </label>
              <select class="custom-select col-8">
                <option selected="">English</option>
                <option value="1">Hindi</option>
                <option value="2">German</option>
              </select>
            </div>
            <div class="form-group row">
              <label class="col-form-label col-4 text-right" for="inputDefault">
                Default time zone
              </label>
              <select class="custom-select col-8">
                <option selected="">GMT 1:00 </option>
                <option value="1">GMT 2:00</option>
                <option value="2">GMT 3:00</option>
                <option value="3">GMT 4:00</option>
              </select>
            </div>
            <div class="form-group row">
              <label class="col-form-label col-4 text-right" for="inputDefault">
                Date format
              </label>
              <select class="custom-select col-8">
                <option selected="">DD/MM/YYYY</option>
                <option value="1">DD/MM/YY</option>
                <option value="2">YY/MM/DD</option>
                <option value="3">MM/DD/YYYY</option>
              </select>
            </div>
            <div class="form-group row">
              <label class="col-form-label col-4 text-right" for="inputDefault">
                Currency
              </label>
              <select class="custom-select col-8">
                <option value="1">Rupee</option>
                <option selected="">Doller</option>
              </select>
            </div>
          </div>
        </div> */}
        <div className="p-3 m-0 border-top">
          <div className="btn btn-primary" onClick={this.onSave}> Save</div> or{" "}
          <a className="btn-link" href="#/admin/dashboard">
            Cancel
          </a>
        </div>
      </div>
    );
  }
}
